export default __webpack_public_path__ + "static/media/Sakura-petal_0006_Layer-9.361d940c.png";